import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

interface IProps {
  title: string;
}

const Head: FC<IProps> = ({
  title: pageTitle,
}) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          keywords
        }
      }
    }
  `);

  const { site: { siteMetadata: { title, description, keywords } } } = data;

  return (
    <Helmet
      title={`${pageTitle} | ${title}`}
      meta={[
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
      ]}
    >
      <html lang="en" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@400;500;700&display=swap" />
      <link rel="stylesheet" type="text/css" href="https://cloud.typography.com/6671318/6370832/css/fonts.css" />
      {/* <link href="https://fonts.googleapis.com/css2?family=Cardo:wght@700&display=swap" rel="stylesheet" /> */}
    </Helmet>
  );
};

export default Head;
